import { useMemo } from 'react';

import type { TFlattenedTreatment } from '@/@types/rcm';

import type { TTreatmentResponse } from '../insuranceExport/types';

export const useTreatmentsToUse = ({
  allTreatments,
  selectedTreatmentIds,
}: {
  allTreatments: TTreatmentResponse[] | TFlattenedTreatment[];
  selectedTreatmentIds: string[];
}) => {
  const treatmentsToUse = useMemo(
    () =>
      allTreatments?.filter((t) =>
        selectedTreatmentIds?.includes(t.txId.toString()),
      ) ?? [],
    [allTreatments, selectedTreatmentIds],
  );

  return { treatmentsToUse };
};
